import React, { useContext, useState } from 'react';
import { Handle, Position } from '@xyflow/react';
import { StorefrontOutlined } from '@mui/icons-material';
import { OrgSettingsContext } from '../../../../../contexts/org-settings-context';
import { Button } from '@mui/material';
import { motion } from 'framer-motion';
import ImportanceBar from '../importance-bar';
import { displayMoney } from '../../../../../utils/money';

interface MerchantsNodeProps {
  data: any;
}

export const MerchantsNode = ({ data }: MerchantsNodeProps) => {
  const { color } = useContext(OrgSettingsContext);
  const isAggregate = data?.isAggregate;
  const expanded = data?.expanded;

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      transition={{ duration: 0.3 }}
      style={{
        background: 'rgba(255, 255, 255, 0.75)',

        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        border: '1px solid #e0f2f1',
        borderRadius: '16px',
        padding: '20px',
        width: 260,
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.08)',
        fontFamily: `'Inter', 'Helvetica Neue', sans-serif`,
        color: '#333',
        position: 'relative',
      }}
    >
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
        <div
          style={{
            background: '#fce4ec',
            borderRadius: '8px',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 10,
          }}
        >
          <StorefrontOutlined style={{ fontSize: 22, color: '#d81b60' }} />
        </div>
        <div style={{ fontSize: '1rem', fontWeight: 600 }}>
          {isAggregate ? 'Merchants' : data.label}
        </div>
      </div>



      {/* Toggle button for aggregate node */}
      {isAggregate && data?.onToggleExpand && (
         <>

          <div style={{ margin: 4}}>
                
          {`💰${displayMoney(data.amount)}`} <br/> {`🕒${displayMoney(data.pending_amount)}`}
         
        </div>
       
        <Button
          variant="outlined"
          onClick={data.onToggleExpand}
          size="small"
          sx={{ mt: 1}}
        >
          {expanded ? 'Collapse' : 'See More'}
        </Button>
        
        </>



        
      )}
      {!isAggregate && (
        <>

          <div style={{ marginTop: 4}}>
                
          {`💰${displayMoney(data.amount)}`} 
      
          <ImportanceBar importance={data.importance} />
        </div>
        <div style={{ marginTop: 4 }}>
          {`🕒${displayMoney(data.pending_amount)}`}
          <ImportanceBar importance={data.pendingImportance} color='orange' />
        </div>
        
        </>
      )}
      {/* Handles */}
      <Handle
        type="source"
        position={Position.Left}
        id="source"
        style={{ opacity: 0 }}
      />
      <Handle
        type="target"
        position={Position.Right}
        id="sink"
        style={{ opacity: 0,}}
      />
    </motion.div>
  );
};
